export default __webpack_public_path__ + "static/media/_DSC0696 (1).f15d8b40.jpg";